export default "__VITE_ASSET__d7974e93__"